export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-white/10 px-6 pb-[max(2.5rem,env(safe-area-inset-bottom))] pt-6 lg:px-12">
      <div className="flex flex-row items-center justify-between gap-3 whitespace-nowrap font-mono text-[9px] uppercase tracking-[0.2em] text-neutral-600 md:gap-4 md:text-[10px] md:tracking-[0.25em]">
        <span>© {new Date().getFullYear()} Pix Marketing</span>
        <span>Design &amp; Marketing</span>
        <span className="hidden sm:inline">Make Yourself Hard to Ignore.</span>
      </div>
    </footer>
  );
}
